module.exports = __webpack_public_path__ + "static/media/image-card-9.7a7cc6ec.png";